(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function smooth() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }
  function init(root) {
    if (root.hasAttribute('data-sb-ready')) return;
    root.setAttribute('data-sb-ready', '');
    var track = root.querySelector('[data-sb-track]');
    var prev = root.querySelector('[data-sb-prev]');
    var next = root.querySelector('[data-sb-next]');
    if (!track || !prev || !next) return;
    function step() {
      var item = track.querySelector('.sb-collection__item');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: smooth() }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: smooth() }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function all() {
    document.querySelectorAll('[data-sb-section="sb-collection"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.hasAttribute('data-sb-ready')) return;
    root.setAttribute('data-sb-ready', '');
    var notice = root.querySelector('[data-sb-notice]');
    if (notice) {
      try { notice.focus({ preventScroll: true }); } catch (e) { notice.focus(); }
    }
    var support = root.querySelector('[data-sb-support-form]');
    if (support) return initSupport(support);
    var form = root.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
    });
  }
  // "Send messages to: Support": the message and its photos or videos go to Scrollbase's Support inbox.
  var API = "https://scrollbase.io";
  var MAX = { files: 6, image: 15728640, video: 104857600, total: 157286400 };
  function isVideo(f) { return /^video\//.test(f.type) || /\.(mov|mp4|webm)$/i.test(f.name); }
  function isMedia(f) { return /^(image|video)\//.test(f.type) || /\.(heic|heif|mov|mp4|webm)$/i.test(f.name); }
  function sizeOf(n) { return n >= 1048576 ? (n / 1048576).toFixed(n >= 10485760 ? 0 : 1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB'; }
  function initSupport(form) {
    var preview = document.documentElement.hasAttribute('data-sb-preview');
    var input = form.querySelector('[data-sb-support-file]');
    var drop = form.querySelector('[data-sb-support-drop]');
    var thumbs = form.querySelector('[data-sb-support-thumbs]');
    var notice = form.querySelector('[data-sb-support-notice]');
    var bar = form.querySelector('[data-sb-support-progress]');
    var btn = form.querySelector('[data-sb-support-submit]');
    var label = btn ? btn.textContent : '';
    var files = [];
    function say(text, ok) {
      notice.hidden = false;
      notice.className = 'sb-contact__notice sb-contact__notice--' + (ok ? 'ok' : 'error');
      notice.textContent = text;
      try { notice.focus({ preventScroll: false }); } catch (e) { notice.focus(); }
    }
    function total() { return files.reduce(function (n, f) { return n + f.size; }, 0); }
    function render() {
      if (!thumbs) return;
      thumbs.textContent = '';
      files.forEach(function (f, i) {
        var li = document.createElement('li');
        li.className = 'sb-contact__thumb';
        var url = URL.createObjectURL(f);
        var media;
        if (isVideo(f)) {
          media = document.createElement('video');
          media.src = url + '#t=0.1';
          media.muted = true;
          media.playsInline = true;
          media.preload = 'metadata';
          var tag = document.createElement('span');
          tag.className = 'sb-contact__thumb-tag';
          tag.textContent = 'Video';
          li.appendChild(tag);
        } else {
          media = document.createElement('img');
          media.src = url;
          media.alt = f.name;
        }
        media.className = 'sb-contact__thumb-media';
        li.insertBefore(media, li.firstChild);
        var size = document.createElement('span');
        size.className = 'sb-contact__thumb-size';
        size.textContent = sizeOf(f.size);
        li.appendChild(size);
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'sb-contact__thumb-remove';
        x.setAttribute('aria-label', 'Remove ' + f.name);
        x.textContent = '\u00d7';
        x.addEventListener('click', function () { files.splice(i, 1); render(); });
        li.appendChild(x);
        thumbs.appendChild(li);
      });
      if (files.length && files.length < MAX.files && input) {
        var more = document.createElement('li');
        var add = document.createElement('label');
        add.className = 'sb-contact__add';
        add.setAttribute('for', input.id);
        add.setAttribute('aria-label', 'Add more');
        add.textContent = '+';
        more.appendChild(add);
        thumbs.appendChild(more);
      }
      drop.classList.toggle('is-full', files.length > 0);
    }
    function add(list) {
      [].slice.call(list || []).forEach(function (f) {
        if (!isMedia(f)) return say(f.name + " isn't a photo or video.");
        if (f.size > (isVideo(f) ? MAX.video : MAX.image)) return say(f.name + ' is too big (' + (isVideo(f) ? 'videos up to 100 MB' : 'photos up to 15 MB') + ').');
        if (files.length >= MAX.files) return say('You can add up to ' + MAX.files + ' photos or videos.');
        if (total() + f.size > MAX.total) return say('Those files are too big together. Try fewer or shorter videos.');
        files.push(f);
      });
      render();
    }
    if (input) input.addEventListener('change', function () { add(input.files); input.value = ''; });
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (t) {
        drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (t) {
        drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); });
      });
      drop.addEventListener('drop', function (e) { if (e.dataTransfer) add(e.dataTransfer.files); });
    }
    function field(name) { var el = form.elements[name]; return el ? String(el.value || '').trim() : ''; }
    function busy(on) {
      if (!btn) return;
      btn.disabled = on;
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      btn.textContent = on ? (form.getAttribute('data-sending') || label) : label;
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      notice.hidden = true;
      var bad = [];
      ['name', 'email', 'message'].forEach(function (n) {
        var el = form.elements[n];
        var v = field(n);
        var ok = !!v && (n !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v));
        if (el) el.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (!ok) bad.push(el);
      });
      if (bad.length) {
        say(form.getAttribute('data-error') || 'Please check the fields and try again.');
        if (bad[0]) bad[0].focus();
        return;
      }
      if (preview) return say('Preview: nothing was sent. On your store, this message and its files go to your Support inbox.', true);
      var data = new FormData();
      ['name', 'email', 'phone', 'order', 'topic', 'message', 'website'].forEach(function (n) { data.append(n, field(n)); });
      data.append('shop', form.getAttribute('data-shop') || '');
      data.append('page', location.origin + location.pathname);
      files.forEach(function (f) { data.append('files', f, f.name); });
      busy(true);
      var fill = bar ? bar.firstElementChild : null;
      if (bar) bar.hidden = !files.length;
      if (fill) fill.style.width = '0%';
      var xhr = new XMLHttpRequest();
      xhr.open('POST', API + '/api/support/form');
      xhr.upload.onprogress = function (ev) { if (fill && ev.lengthComputable) fill.style.width = Math.round((ev.loaded / ev.total) * 100) + '%'; };
      xhr.onload = function () {
        var r = {};
        try { r = JSON.parse(xhr.responseText); } catch (err) {}
        if (xhr.status >= 200 && xhr.status < 300 && r.ok) {
          form.querySelector('[data-sb-support-fields]').hidden = true;
          if (btn) btn.hidden = true;
          if (bar) bar.hidden = true;
          return say(form.getAttribute('data-ok') || 'Thanks, we got your message.', true);
        }
        busy(false);
        if (bar) bar.hidden = true;
        say(r.error || form.getAttribute('data-error') || 'That didn\'t send. Try again.');
      };
      xhr.onerror = function () {
        busy(false);
        if (bar) bar.hidden = true;
        say("We couldn't send that. Check your connection and try again.");
      };
      xhr.send(data);
    });
  }
  function all() {
    document.querySelectorAll('[data-sb-section="sb-contact"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  var TYPE = 'sb-gallery';
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function setup(root) {
    var track = root.querySelector('[data-sb-track]');
    var nav = root.querySelector('[data-sb-nav]');
    if (!track || !nav) return;
    var prev = nav.querySelector('[data-sb-prev]');
    var next = nav.querySelector('[data-sb-next]');
    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduce && reduce.matches ? 'auto' : 'smooth' });
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function init() {
    var roots = document.querySelectorAll('[data-sb-section="' + TYPE + '"]:not([data-sb-ready])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-sb-ready', '');
      setup(roots[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var TYPE = 'sb-hero';
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function wire(video, root) {
    var box = video.closest('[data-sb-video]') || root;
    var btn = box.querySelector('[data-sb-video-toggle]');
    var held = !!(reduce && reduce.matches);
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    function show() { if (btn) btn.setAttribute('aria-pressed', video.paused ? 'true' : 'false'); }
    function play() {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(show);
    }
    if (held) { video.removeAttribute('autoplay'); video.pause(); }
    video.addEventListener('play', show);
    video.addEventListener('pause', show);
    if (btn) btn.addEventListener('click', function () {
      if (video.paused) { held = false; play(); } else { held = true; video.pause(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { if (!held) play(); }
          else if (!video.paused) video.pause();
        });
      }, { threshold: 0.2 }).observe(box);
    } else if (!held) play();
    show();
  }
  function init() {
    var roots = document.querySelectorAll('[data-sb-section="' + TYPE + '"]:not([data-sb-ready])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-sb-ready', '');
      var videos = roots[i].querySelectorAll('video');
      for (var j = 0; j < videos.length; j++) wire(videos[j], roots[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-media-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  var TYPE = 'sb-media-text';
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function wire(video, root) {
    var box = video.closest('[data-sb-video]') || root;
    var btn = box.querySelector('[data-sb-video-toggle]');
    var held = !!(reduce && reduce.matches);
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    function show() { if (btn) btn.setAttribute('aria-pressed', video.paused ? 'true' : 'false'); }
    function play() {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(show);
    }
    if (held) { video.removeAttribute('autoplay'); video.pause(); }
    video.addEventListener('play', show);
    video.addEventListener('pause', show);
    if (btn) btn.addEventListener('click', function () {
      if (video.paused) { held = false; play(); } else { held = true; video.pause(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { if (!held) play(); }
          else if (!video.paused) video.pause();
        });
      }, { threshold: 0.2 }).observe(box);
    } else if (!held) play();
    show();
  }
  function init() {
    var roots = document.querySelectorAll('[data-sb-section="' + TYPE + '"]:not([data-sb-ready])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-sb-ready', '');
      var videos = roots[i].querySelectorAll('video');
      for (var j = 0; j < videos.length; j++) wire(videos[j], roots[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.SbProductSection) return;
  window.SbProductSection = true;
  var SECTION = '[data-sb-section="sb-product"]';
  var REVIEWS = '[data-sb-section="sb-reviews"]:not([hidden]), #judgeme_product_reviews, .jdgm-review-widget, #shopify-product-reviews, #looxReviews, .stamped-main-widget, .yotpo-main-widget, #reviews';
  var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function readJson(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function decode(s) { var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }

  /* The store's money format, read from a formatted sample (123456 cents), so prices update in the store's own style. */
  function moneyFormat(sample) {
    sample = decode(String(sample || '')).trim();
    var first = sample.search(/\d/);
    if (first < 0) return function (c) { return ((Number(c) || 0) / 100).toFixed(2); };
    var last = sample.length - 1 - sample.split('').reverse().join('').search(/\d/);
    var pre = sample.slice(0, first), suf = sample.slice(last + 1), core = sample.slice(first, last + 1);
    var thou = ',', dec = '.', places = 2, m = core.match(/^1(\D?)234(\D)56$/);
    if (m) { thou = m[1]; dec = m[2]; }
    else { m = core.match(/^1(\D?)235$/); if (m) { thou = m[1]; dec = ''; places = 0; } }
    return function (cents) {
      var parts = ((Number(cents) || 0) / 100).toFixed(places).split('.');
      return pre + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (places ? dec + parts[1] : '') + suf;
    };
  }

  function gallery(root) {
    var track = root.querySelector('[data-sb-track]');
    var none = { toVariant: function () {}, toSlide: function () {} };
    if (!track) return none;
    var slides = all(track, '[data-sb-slide]');
    var thumbs = all(root, '[data-sb-thumb]');
    var dots = all(root, '[data-sb-dot]');
    var active = -1, timer = 0;
    function pad() { var p = parseFloat(getComputedStyle(track).scrollPaddingLeft); return isNaN(p) ? 0 : p; }
    function mark(i) {
      if (i === active) return;
      active = i;
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      slides.forEach(function (s, k) {
        var v = s.querySelector('video');
        if (!v) return;
        if (k === i) { v.muted = true; v.playsInline = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
      var t = thumbs[i], strip = t && t.parentNode;
      if (strip && strip.scrollWidth > strip.clientWidth) strip.scrollLeft = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
      if (strip && strip.scrollHeight > strip.clientHeight) strip.scrollTop = t.offsetTop - (strip.clientHeight - t.offsetHeight) / 2;
    }
    function go(i) {
      var s = slides[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - pad(), behavior: smooth ? 'smooth' : 'auto' });
      mark(i);
    }
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var x = track.scrollLeft + pad(), best = 0, dist = Infinity;
        slides.forEach(function (s, k) { var d = Math.abs(s.offsetLeft - x); if (d < dist) { dist = d; best = k; } });
        mark(best);
      }, 60);
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    all(root, '[data-sb-step]').forEach(function (b) {
      b.addEventListener('click', function () { go(Math.max(0, Math.min(slides.length - 1, active + Number(b.getAttribute('data-sb-step'))))); });
    });
    mark(0);
    /* A variant's picture: by its media id, else by its image (id, then file name), since not every product JSON
       carries featured_media. */
    function file(src) { return String(src || '').split('?')[0].split('/').pop(); }
    return {
      toSlide: go,
      toVariant: function (v) {
        var media = v.featured_media && v.featured_media.id, image = v.featured_image || null;
        if (!media && !image) return;
        for (var k = 0; k < slides.length; k++) {
          var s = slides[k];
          if (media && String(s.getAttribute('data-media-id')) === String(media)) { go(k); return; }
          if (image && image.id && String(s.getAttribute('data-image-id')) === String(image.id)) { go(k); return; }
        }
        var name = image && file(image.src);
        if (!name) return;
        for (var j = 0; j < slides.length; j++) {
          var img = slides[j].querySelector('img');
          if (img && file(img.getAttribute('src')) === name) { go(j); return; }
        }
      }
    };
  }

  /* Swatches named with a color CSS doesn't know ("Sand") show their name only, not an empty circle. */
  function swatches(root) {
    if (!window.CSS || !CSS.supports) return;
    all(root, '.sb-product__chip').forEach(function (chip) {
      var value = chip.style.getPropertyValue('--sb-swatch').trim();
      if (!value || !(CSS.supports('color', value) || /^url\(/.test(value))) chip.hidden = true;
    });
  }

  /* A sticky theme header would cover the buy box that stays in view: measure it once. */
  function headerOffset(root) {
    var h = document.querySelector('.section-header, sticky-header, .shopify-section-header-sticky');
    if (!h) return;
    var pos = getComputedStyle(h).position;
    if (pos === 'sticky' || pos === 'fixed') root.style.setProperty('--sb-header-offset', Math.round(h.getBoundingClientRect().height) + 'px');
  }

  /* The phone bar shows once the main button has scrolled off the top. IntersectionObserver, plus a scroll listener
     because observers pause in background tabs and a bar that never shows never sells. */
  function stickyBar(root) {
    var bar = root.querySelector('[data-sb-bar]'), main = root.querySelector('[data-sb-main-button]');
    if (!bar || !main) return;
    var shown = false, padded = 0, io = null, pending = 0;
    function set(on) {
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on && !padded && bar.offsetHeight) {
        padded = bar.offsetHeight;
        var base = parseFloat(getComputedStyle(document.body).paddingBottom) || 0;
        document.body.style.paddingBottom = (base + padded) + 'px';
      }
    }
    function stop() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (io) io.disconnect();
      if (padded) document.body.style.paddingBottom = '';
    }
    function check() {
      pending = 0;
      if (!root.isConnected) { stop(); return; }
      set(main.getBoundingClientRect().bottom < 0);
    }
    /* A short timeout, not requestAnimationFrame: frames don't run in background tabs or some webviews. */
    function onScroll() { if (!pending) pending = setTimeout(check, 50); }
    if ('IntersectionObserver' in window) { io = new IntersectionObserver(function () { check(); }); io.observe(main); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    var btn = bar.querySelector('[data-sb-bar-button]');
    if (btn) btn.addEventListener('click', function () { if (!main.disabled) main.click(); });
    check();
  }

  function reviewsLink(root) {
    var link = root.querySelector('[data-sb-to-reviews]');
    if (!link) return;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.querySelector(REVIEWS);
      if (target) target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    });
  }

  function init(root) {
    if (root.getAttribute('data-sb-ready') === '1') return;
    root.setAttribute('data-sb-ready', '1');
    var g = gallery(root);
    root.sbGallery = g;
    headerOffset(root);
    stickyBar(root);
    reviewsLink(root);
    swatches(root);

    var product = readJson(root.querySelector('[data-sb-product-json]'));
    var cfg = readJson(root.querySelector('[data-sb-config]')) || {};
    if (!product || !product.variants || !product.variants.length) return;
    var money = moneyFormat(cfg.money);
    var variants = product.variants;
    var count = Math.max(1, (product.options || []).length);
    var groups = all(root, '[data-sb-option]');
    var idInput = root.querySelector('[data-sb-variant-id]');
    var qty = root.querySelector('[data-sb-qty]');

    function opts(v) { return v.options && v.options.length ? v.options : [v.option1, v.option2, v.option3].slice(0, count); }
    function find(sel) {
      for (var i = 0; i < variants.length; i++) {
        var o = opts(variants[i]), ok = true;
        for (var j = 0; j < sel.length; j++) if (o[j] !== sel[j]) { ok = false; break; }
        if (ok) return variants[i];
      }
      return null;
    }
    function byId(id) { for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i]; return null; }
    function firstWith(i, val) { for (var k = 0; k < variants.length; k++) if (opts(variants[k])[i] === val) return variants[k]; return null; }
    function chosen() {
      return groups.map(function (grp) {
        var s = grp.querySelector('select');
        if (s) return s.value;
        var c = grp.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function text(sel, value) { all(root, sel).forEach(function (el) { el.textContent = value; }); }
    function show(sel, on) { all(root, sel).forEach(function (el) { el.hidden = !on; }); }

    function update(fromUser) {
      var sel = chosen();
      var v = groups.length ? find(sel) : (idInput && byId(idInput.value)) || variants[0];

      groups.forEach(function (grp, i) {
        var label = grp.querySelector('[data-sb-option-value]');
        if (label) label.textContent = sel[i] || '';
        all(grp, 'input, option').forEach(function (inp) {
          var test = sel.slice();
          test[i] = inp.value;
          var match = find(test);
          var any = variants.some(function (x) { return x.available && opts(x)[i] === inp.value; });
          var sold = !match || !match.available;
          inp.disabled = !any && !(inp.checked || inp.selected);
          if (inp.tagName === 'OPTION') {
            var name = inp.getAttribute('data-name') || inp.value;
            inp.textContent = sold && cfg.soldout ? name + ' - ' + cfg.soldout : name;
            return;
          }
          var box = inp.closest('[data-sb-value]');
          if (!box) return;
          box.classList.toggle('is-soldout', sold);
          var price = box.querySelector('[data-sb-value-price]'), was = box.querySelector('[data-sb-value-compare]'), pv = match || firstWith(i, inp.value);
          if (price && pv) {
            price.textContent = money(pv.price);
            if (was) was.textContent = pv.compare_at_price > pv.price ? money(pv.compare_at_price) : '';
          }
        });
      });

      if (v) {
        var sale = v.compare_at_price > v.price, amount = '';
        text('[data-sb-price], [data-sb-bar-price]', money(v.price));
        text('[data-sb-compare], [data-sb-bar-compare]', sale ? money(v.compare_at_price) : '');
        show('[data-sb-compare], [data-sb-bar-compare]', sale);
        if (sale && cfg.savings === 'percent') {
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          if (pct >= 1) amount = pct + '%';
        } else if (sale && cfg.savings === 'amount') {
          amount = money(v.compare_at_price - v.price);
        }
        text('[data-sb-savings]', amount ? String(cfg.savingsLabel || '[amount]').replace('[amount]', amount) : '');
        show('[data-sb-savings]', !!amount);
      }

      var ok = !!(v && v.available);
      /* The form's id is what Add to cart and the express buttons buy: emptied when the picked combination doesn't
         exist, so nothing can buy the variant picked before. A 'change' lets Shopify's buttons (and the Shop Pay
         installments line) follow, the way Dawn does; nothing in this section listens for it on the id. */
      if (idInput) {
        var nextId = v ? String(v.id) : '';
        if (idInput.value !== nextId) {
          idInput.value = nextId;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      /* Shop Pay, Apple Pay and Google Pay can't be switched off from here, so they hide while Add to cart can't buy. */
      show('.sb-product__express', ok);
      text('[data-sb-button-label]', !v ? (cfg.unavailable || cfg.soldout || '') : ok ? (cfg.button || '') : (cfg.soldout || ''));
      all(root, '[data-sb-main-button], [data-sb-bar-button]').forEach(function (b) { b.disabled = !ok; });
      var n = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
      text('[data-sb-button-price]', ok ? money(v.price * n) : '');
      show('[data-sb-button-price]', ok);

      if (fromUser && v) {
        g.toVariant(v);
        if (window.history && history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            history.replaceState(history.state, '', u.toString());
          } catch (e) {}
        }
        root.dispatchEvent(new CustomEvent('sb:variant-change', { bubbles: true, detail: { variant: v } }));
      }
    }

    groups.forEach(function (grp) { grp.addEventListener('change', function () { update(true); }); });
    if (qty) {
      all(root, '[data-sb-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.getAttribute('data-sb-qty-step')));
          update(false);
        });
      });
      qty.addEventListener('change', function () { update(false); });
    }
    update(false);
  }

  function initAll() { all(document, SECTION).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest ? e.target.closest('[data-sb-slide]') : null;
    var root = slide && slide.closest(SECTION);
    if (root && root.sbGallery) root.sbGallery.toSlide(Number(slide.getAttribute('data-sb-slide')));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.SbReviewsSection) return;
  window.SbReviewsSection = true;
  var SECTION = '[data-sb-section="sb-reviews"]';
  /* Scrollbase's preview (html[data-sb-preview]): the form shows and checks what's typed, but nothing is sent. */
  var PREVIEW = document.documentElement.hasAttribute('data-sb-preview');
  var PREVIEW_NOTE = "This is the preview, so nothing was sent. On your store, reviews sent here wait for you in Reviews.";

  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function readJson(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }

  function init(root) {
    if (root.getAttribute('data-sb-ready') === '1') return;
    root.setAttribute('data-sb-ready', '1');
    var cfg = readJson(root.querySelector('[data-sb-config]'));
    var list = root.querySelector('[data-sb-list]');
    if (!cfg || !list || (!cfg.url && cfg.mode !== 'scrollbase')) return;
    var more = root.querySelector('[data-sb-more]');
    var star = root.querySelector('[data-sb-star]');
    var tick = root.querySelector('[data-sb-tick]');
    var per = Math.max(1, Number(cfg.perPage) || 6);
    var reviews = [], shown = 0, page = 1, next = null, remote = false, busy = false;
    var base;
    try { base = new URL(cfg.url || window.location.href, window.location.href); } catch (e) { return; }

    function stars(rating, max) {
      var wrap = el('span', 'sb-reviews__stars');
      wrap.setAttribute('aria-hidden', 'true');
      wrap.style.setProperty('--sb-fill', Math.max(0, Math.min(100, rating / (max || 5) * 100)) + '%');
      for (var r = 0; r < 2; r++) {
        var row = el('span', 'sb-reviews__stars-row' + (r ? ' sb-reviews__stars-row--fill' : ''));
        for (var i = 0; i < 5 && star; i++) row.appendChild(star.content.cloneNode(true));
        wrap.appendChild(row);
      }
      return wrap;
    }
    function safeUrl(u) {
      if (typeof u !== 'string' || !u) return null;
      try { var x = new URL(u, base); return /^https?:$/.test(x.protocol) ? x.toString() : null; } catch (e) { return null; }
    }
    function item(r) {
      var li = el('li', 'sb-reviews__item');
      var rating = Math.max(0, Math.min(5, Number(r.rating) || 0));
      var head = el('div', 'sb-reviews__item-head');
      var left = el('span');
      left.appendChild(stars(rating, 5));
      var said = el('span', 'sb-visually-hidden');
      said.textContent = rating + ' / 5';
      left.appendChild(said);
      head.appendChild(left);
      var d = r.date ? new Date(r.date) : null;
      if (r.when) {
        var w = el('time', 'sb-reviews__date');
        w.dateTime = String(r.date || '');
        w.textContent = String(r.when);
        head.appendChild(w);
      } else if (d && !isNaN(d.getTime())) {
        var t = el('time', 'sb-reviews__date');
        t.dateTime = d.toISOString().slice(0, 10);
        t.textContent = d.toLocaleDateString(document.documentElement.lang || undefined, { year: 'numeric', month: 'short', day: 'numeric' });
        head.appendChild(t);
      }
      li.appendChild(head);
      if (r.title) { var h = el('h3', 'sb-reviews__title'); h.textContent = String(r.title); li.appendChild(h); }
      if (r.body) { var p = el('p', 'sb-reviews__text'); p.textContent = String(r.body); li.appendChild(p); }
      var photos = (Array.isArray(r.photos) ? r.photos : []).map(function (x) { return safeUrl(typeof x === 'string' ? x : x && x.url); }).filter(Boolean).slice(0, 4);
      if (photos.length) {
        var row = el('div', 'sb-reviews__photos');
        photos.forEach(function (src) {
          var a = el('a', 'sb-reviews__photo');
          a.href = src;
          a.target = '_blank';
          a.rel = 'noopener';
          var img = el('img');
          img.src = src;
          img.alt = cfg.photoAlt || '';
          img.loading = 'lazy';
          img.width = 72;
          img.height = 72;
          a.appendChild(img);
          row.appendChild(a);
        });
        li.appendChild(row);
      }
      var name = String(r.name || '').trim();
      if (name || (r.verified && cfg.verified)) {
        var by = el('p', 'sb-reviews__author');
        if (name) { var nm = el('span', 'sb-reviews__name'); nm.textContent = name; by.appendChild(nm); }
        if (r.verified && cfg.verified) {
          var vf = el('span', 'sb-reviews__verified');
          if (tick) vf.appendChild(tick.content.cloneNode(true));
          vf.appendChild(document.createTextNode(cfg.verified));
          by.appendChild(vf);
        }
        li.appendChild(by);
      }
      if (r.reply && cfg.reply) {
        var rp = el('div', 'sb-reviews__reply');
        var rl = el('p', 'sb-reviews__reply-label');
        rl.textContent = cfg.reply;
        var rt = el('p', 'sb-reviews__reply-text');
        rt.textContent = String(r.reply);
        rp.appendChild(rl);
        rp.appendChild(rt);
        li.appendChild(rp);
      }
      return li;
    }
    if (cfg.mode === 'scrollbase') return scrollbase(root, cfg, list, more, item, per);
    function summary(rating, count) {
      var box = root.querySelector('[data-sb-summary]');
      if (!box || box.hasAttribute('data-sb-from-shopify')) return;
      rating = Number(rating);
      count = Number(count);
      if (!(rating > 0) || !(count > 0)) return;
      box.querySelector('[data-sb-score]').textContent = (Math.round(rating * 10) / 10).toFixed(1);
      var s = box.querySelector('[data-sb-summary-stars]');
      if (s) s.style.setProperty('--sb-fill', Math.min(100, rating / 5 * 100) + '%');
      box.querySelector('[data-sb-based]').textContent = String(cfg.summary || '').replace('[count]', count.toLocaleString());
      box.hidden = false;
    }
    function target() {
      if (next) return safeUrl(next);
      var u = new URL(base.toString());
      if (cfg.product) u.searchParams.set('product', cfg.product);
      u.searchParams.set('page', String(page));
      u.searchParams.set('per', String(per));
      return u.toString();
    }
    function load() {
      var url = target();
      if (!url) return Promise.reject(new Error('bad link'));
      busy = true;
      if (more) more.disabled = true;
      return fetch(url, { headers: { Accept: 'application/json' } }).then(function (res) {
        if (!res.ok) throw new Error(String(res.status));
        return res.json();
      }).then(function (data) {
        data = data || {};
        var items = (Array.isArray(data.reviews) ? data.reviews : []).filter(function (r) { return r && (r.body || r.title) && Number(r.rating) > 0; });
        reviews = reviews.concat(items);
        next = typeof data.next === 'string' && data.next ? data.next : null;
        remote = items.length > 0 && !!(next || data.hasMore || (Number(data.pages) > Number(data.page || page)));
        page += 1;
        var sum = data.summary || {};
        summary(sum.rating != null ? sum.rating : data.average, sum.count != null ? sum.count : data.total);
      }).then(function () { busy = false; if (more) more.disabled = false; }, function (err) { busy = false; if (more) more.disabled = false; throw err; });
    }
    function render() {
      var end = Math.min(reviews.length, shown + per);
      for (; shown < end; shown++) list.appendChild(item(reviews[shown]));
      if (more) more.hidden = !(shown < reviews.length || remote);
      var box = root.querySelector('[data-sb-summary]');
      if (shown > 0 || (box && !box.hidden)) root.hidden = false;
    }
    if (more) more.addEventListener('click', function () {
      if (busy) return;
      if (shown < reviews.length) render();
      else if (remote) load().then(render).catch(function () { more.hidden = true; });
    });
    load().then(render).catch(function () {});
  }

  // Scrollbase's reviews: the first ones are in the page (the product's metafield); "Show more" reveals the rest of
  // those, then reads further ones from Scrollbase's public link. The form posts there too and always waits for the
  // brand to read it.
  function scrollbase(root, cfg, list, more, item, per) {
    var busy = false;
    function remote() { return !!cfg.url && list.children.length < Number(cfg.count || 0); }
    function update() { if (more) more.hidden = !(all(list, '[data-sb-later][hidden]').length || remote()); }
    if (more) more.addEventListener('click', function () {
      if (busy) return;
      var later = all(list, '[data-sb-later][hidden]');
      if (later.length) {
        later.slice(0, per).forEach(function (li) { li.hidden = false; });
        update();
        return;
      }
      if (!remote()) return update();
      busy = true;
      more.disabled = true;
      var u = new URL(cfg.url);
      u.searchParams.set('shop', cfg.shop || '');
      u.searchParams.set('product', cfg.product || '');
      u.searchParams.set('offset', String(list.children.length));
      u.searchParams.set('per', String(per));
      fetch(u.toString(), { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); }).then(function (data) {
        var items = Array.isArray(data && data.reviews) ? data.reviews : [];
        items.forEach(function (r) { list.appendChild(item(r)); });
        if (!items.length || !data.hasMore) cfg.count = list.children.length;
      }).catch(function () { cfg.count = list.children.length; }).then(function () { busy = false; more.disabled = false; update(); });
    });
    update();
    var form = root.querySelector('[data-sb-form]');
    if (!form || !cfg.url) return;
    var draft = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
    var rating = 0, photos = [], sending = false;
    var msg = form.querySelector('[data-sb-msg]');
    var stars = all(form, '[data-sb-star-value]');
    function say(t) { if (msg) msg.textContent = t || ''; }
    function paint(n) { stars.forEach(function (b) { var v = Number(b.getAttribute('data-sb-star-value')); b.classList.toggle('is-on', v <= n); b.setAttribute('aria-checked', v === rating ? 'true' : 'false'); }); }
    stars.forEach(function (b) {
      b.addEventListener('click', function () { rating = Number(b.getAttribute('data-sb-star-value')); paint(rating); });
      b.addEventListener('mouseenter', function () { paint(Number(b.getAttribute('data-sb-star-value'))); });
      b.addEventListener('mouseleave', function () { paint(rating); });
    });
    var q = '?shop=' + encodeURIComponent(cfg.shop || '') + '&product=' + encodeURIComponent(cfg.product || '');
    var file = form.querySelector('[data-sb-photos]');
    var thumbs = form.querySelector('[data-sb-thumbs]');
    var addTile = form.querySelector('[data-sb-photo-add]');
    function shown() { return thumbs ? thumbs.querySelectorAll('.sb-reviews__thumb').length : 0; }
    function syncAdd() { if (addTile) addTile.hidden = shown() >= 6; }
    /* A picked photo as a thumbnail with a remove button; removing it takes it out of the review too. */
    function thumb(f, entry) {
      if (!thumbs) return;
      var url = URL.createObjectURL(f);
      var wrap = el('span', 'sb-reviews__thumb');
      var img = el('img');
      img.alt = '';
      img.src = url;
      var drop = el('button', 'sb-reviews__thumb-x');
      drop.type = 'button';
      drop.setAttribute('aria-label', 'Remove photo');
      drop.textContent = '\u00d7';
      drop.addEventListener('click', function (e) {
        e.preventDefault();
        if (entry) photos = photos.filter(function (p) { return p !== entry; });
        try { URL.revokeObjectURL(url); } catch (err) {}
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        syncAdd();
      });
      wrap.appendChild(img);
      wrap.appendChild(drop);
      thumbs.appendChild(wrap);
      syncAdd();
    }
    if (file) file.addEventListener('change', function () {
      var files = Array.prototype.slice.call(file.files || []).filter(function (f) { return /^image\//.test(f.type); }).slice(0, 6 - photos.length);
      file.value = '';
      if (PREVIEW) {
        files.slice(0, Math.max(0, 6 - shown())).forEach(function (f) { thumb(f, null); });
        return;
      }
      files.reduce(function (p, f) {
        return p.then(function () {
          return fetch(cfg.url + '/photo' + q + '&draft=' + encodeURIComponent(draft), { method: 'POST', headers: { 'Content-Type': f.type }, body: f })
            .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.error || ''); return j; }); })
            .then(function (j) {
              var entry = { key: j.key, thumbKey: j.thumbKey, width: j.width, height: j.height };
              photos.push(entry);
              thumb(f, entry);
            });
        });
      }, Promise.resolve()).catch(function (e) { say(e && e.message); });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending) return;
      if (!rating) { say(cfg.pickRating); return; }
      if (PREVIEW) { say(PREVIEW_NOTE); return; }
      var data = new FormData(form);
      sending = true;
      say('…');
      fetch(cfg.url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ shop: cfg.shop, handle: cfg.product, draft: draft, rating: rating, title: data.get('title'), body: data.get('body'), name: data.get('name'), email: data.get('email'), website: data.get('website'), photos: photos, via: 'form' }) })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.error || ''); }); })
        .then(function () { form.reset(); photos = []; rating = 0; paint(0); if (thumbs) thumbs.innerHTML = ''; syncAdd(); say(cfg.thanks); draft = String(Date.now()) + Math.random().toString(16).slice(2); if (window.crypto && crypto.randomUUID) draft = crypto.randomUUID(); })
        .catch(function (err) { say(err && err.message); })
        .then(function () { sending = false; });
    });
  }

  function initAll() { all(document, SECTION).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-track-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  var API = "https://scrollbase.io";
  var STEPS = ['ordered', 'shipped', 'out', 'delivered'];
  function day(iso) {
    if (!iso) return '';
    try { return new Date(iso).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return ''; }
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function sample() {
    var now = Date.now();
    var at = function (d) { return new Date(now + d * 86400000).toISOString(); };
    return {
      name: '#1001', placedAt: at(-3), state: 'shipped', step: 1, dates: { ordered: at(-3), shipped: at(-2) }, estimatedAt: at(2), waiting: 0, statusUrl: null,
      shipments: [{ state: 'shipped', carrier: 'USPS', number: '9400 1000 0000 0000 0000 00', url: '#', shippedAt: at(-2) }],
      items: [{ title: 'Your product', variant: null, quantity: 1, image: null }],
    };
  }
  function init(root) {
    if (root.hasAttribute('data-sb-ready')) return;
    root.setAttribute('data-sb-ready', '');
    var form = root.querySelector('[data-sb-track-form]');
    var out = root.querySelector('[data-sb-track-result]');
    if (!form || !out) return;
    var preview = document.documentElement.hasAttribute('data-sb-preview');
    var notice = form.querySelector('[data-sb-track-notice]');
    var btn = form.querySelector('[data-sb-track-submit]');
    var btnText = btn ? btn.querySelector('span') : null;
    var label = btnText ? btnText.textContent : '';
    var w = out.dataset;
    function say(text) {
      notice.hidden = !text;
      notice.textContent = text || '';
      if (text) { try { notice.focus({ preventScroll: true }); } catch (e) { notice.focus(); } }
    }
    function busy(on) {
      if (!btn) return;
      btn.disabled = on;
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (btnText) btnText.textContent = on ? (form.getAttribute('data-finding') || label) : label;
    }
    function show(o, isSample) {
      out.querySelector('[data-sb-track-sample]').hidden = !isSample;
      out.querySelector('[data-sb-track-meta]').textContent = (w.orderWord || 'Order') + ' ' + o.name + ' \u00b7 ' + (w.placedWord || 'Placed') + ' ' + day(o.placedAt);
      var key = 'state' + o.state.charAt(0).toUpperCase() + o.state.slice(1);
      out.querySelector('[data-sb-track-state]').textContent = w[key] || o.state;
      var eta = out.querySelector('[data-sb-track-eta]');
      eta.textContent = '';
      eta.hidden = !(o.estimatedAt || o.waiting);
      if (o.estimatedAt) {
        eta.appendChild(document.createTextNode((w.estimate || 'Estimated delivery') + ' '));
        eta.appendChild(el('strong', '', day(o.estimatedAt)));
      } else if (o.waiting) {
        eta.textContent = o.waiting + ' ' + (w.waiting || 'still to ship');
      }
      var steps = out.querySelector('[data-sb-track-steps]');
      steps.textContent = '';
      steps.hidden = o.state === 'cancelled';
      STEPS.forEach(function (s, i) {
        var li = el('li', 'sb-track__step' + (i < o.step ? ' is-done' : i === o.step ? ' is-now' : ''));
        li.appendChild(el('span', 'sb-track__dot'));
        li.appendChild(el('span', 'sb-track__step-name', w['step' + s.charAt(0).toUpperCase() + s.slice(1)] || s));
        if (o.dates && o.dates[s]) li.appendChild(el('span', 'sb-track__step-date', day(o.dates[s])));
        steps.appendChild(li);
      });
      var ships = out.querySelector('[data-sb-track-shipments]');
      ships.textContent = '';
      (o.shipments || []).forEach(function (sh) {
        if (!sh.carrier && !sh.number && !sh.url) return;
        var row = el('div', 'sb-track__ship');
        var text = el('div', 'sb-track__ship-text');
        text.appendChild(el('span', 'sb-track__ship-carrier', sh.carrier || (w['state' + sh.state.charAt(0).toUpperCase() + sh.state.slice(1)] || '')));
        if (sh.number) text.appendChild(el('span', 'sb-track__ship-number', sh.number));
        row.appendChild(text);
        if (sh.url) {
          var a = el('a', 'sb-btn sb-track__ship-btn', w.track || 'Track package');
          a.href = sh.url;
          a.target = '_blank';
          a.rel = 'noopener';
          row.appendChild(a);
        }
        ships.appendChild(row);
      });
      var items = out.querySelector('[data-sb-track-items]');
      items.textContent = '';
      if ((o.items || []).length) {
        items.appendChild(el('p', 'sb-track__items-title', w.items || 'In this order'));
        o.items.forEach(function (it) {
          var row = el('div', 'sb-track__item');
          if (it.image) {
            var img = el('img', 'sb-track__thumb');
            img.src = it.image;
            img.alt = '';
            img.loading = 'lazy';
            row.appendChild(img);
          } else row.appendChild(el('span', 'sb-track__thumb'));
          var t = el('div', 'sb-track__item-text');
          t.appendChild(el('span', '', it.title));
          t.appendChild(el('span', 'sb-track__item-sub', [it.variant, '\u00d7 ' + it.quantity].filter(Boolean).join(' \u00b7 ')));
          row.appendChild(t);
          items.appendChild(row);
        });
      }
      var details = out.querySelector('[data-sb-track-details]');
      details.hidden = !(o.statusUrl && w.details);
      if (o.statusUrl && w.details) { details.href = o.statusUrl; details.textContent = w.details; }
      out.hidden = false;
      form.hidden = !isSample;
    }
    out.querySelector('[data-sb-track-again]').addEventListener('click', function () {
      out.hidden = true;
      form.hidden = false;
      form.reset();
      var first = form.elements.order;
      if (first) first.focus();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      say('');
      var bad = [];
      ['order', 'email'].forEach(function (n) {
        var f = form.elements[n];
        var v = f ? String(f.value || '').trim() : '';
        var ok = !!v && (n !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v));
        if (f) f.setAttribute('aria-invalid', ok ? 'false' : 'true');
        if (!ok) bad.push(f);
      });
      if (bad.length) {
        say(form.getAttribute('data-missing') || 'Enter your order number and email.');
        if (bad[0]) bad[0].focus();
        return;
      }
      if (preview) return show(sample(), true);
      busy(true);
      fetch(API + '/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ shop: form.getAttribute('data-shop') || '', order: form.elements.order.value, email: form.elements.email.value, website: form.elements.website ? form.elements.website.value : '' }),
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (r) {
          busy(false);
          if (r && r.ok && r.order) {
            show(r.order, false);
            try { out.focus({ preventScroll: false }); } catch (e) { out.focus(); }
          } else say((r && r.error) || "We couldn't find that order.");
        })
        .catch(function () {
          busy(false);
          say("We couldn't look that up. Check your connection and try again.");
        });
    });
    // The editor's preview shows what a shopper sees with a sample order under the form.
    if (preview) show(sample(), true);
  }
  function all() {
    document.querySelectorAll('[data-sb-section="sb-track-order"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.SbVideoSection) return;
  window.SbVideoSection = true;
  var SECTION = '[data-sb-section="sb-video"]';
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function play(frame, manual) {
    var v = frame.sbVideo;
    if (!v) return;
    var btn = frame.querySelector('[data-sb-play]');
    var p = v.play();
    if (p && p.then) p.then(function () { if (btn) btn.hidden = true; }).catch(function () { if (btn) btn.hidden = false; });
    else if (btn) btn.hidden = true;
    if (manual) frame.sbManual = true;
  }

  function init(root) {
    if (root.getAttribute('data-sb-ready') === '1') return;
    root.setAttribute('data-sb-ready', '1');
    var frames = all(root, '[data-sb-video]');
    frames.forEach(function (frame) {
      var v = frame.querySelector('video');
      if (!v) return;
      frame.sbVideo = v;
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.removeAttribute('autoplay');
      var poster = frame.getAttribute('data-poster');
      if (poster) v.setAttribute('poster', poster);
      var btn = frame.querySelector('[data-sb-play]');
      if (btn) btn.addEventListener('click', function () { play(frame, true); });
      var sound = frame.querySelector('[data-sb-sound]');
      if (sound) {
        sound.hidden = false;
        sound.addEventListener('click', function () {
          var on = v.muted;
          if (on) all(document, '[data-sb-section="sb-video"] video').forEach(function (o) {
            if (o !== v) {
              o.muted = true;
              var s = o.parentNode && o.parentNode.querySelector('[data-sb-sound]');
              if (s) { s.setAttribute('aria-pressed', 'false'); s.textContent = s.getAttribute('data-off') || ''; }
            }
          });
          v.muted = !on;
          sound.setAttribute('aria-pressed', on ? 'true' : 'false');
          sound.textContent = (on ? sound.getAttribute('data-on') : sound.getAttribute('data-off')) || '';
          if (on) play(frame, true);
        });
      }
    });

    if (still || !('IntersectionObserver' in window)) {
      frames.forEach(function (f) { var b = f.querySelector('[data-sb-play]'); if (b && f.sbVideo) b.hidden = false; });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target.sbVideo;
          if (!v) return;
          if (e.isIntersecting) play(e.target, false);
          else if (!v.paused) v.pause();
        });
      }, { threshold: 0.35 });
      frames.forEach(function (f) { if (f.sbVideo) io.observe(f); });
    }

    var list = root.querySelector('[data-sb-video-list]');
    var arrows = all(root, '[data-sb-step]');
    if (list && arrows.length) {
      var timer = 0;
      var sync = function () {
        var over = list.scrollWidth > list.clientWidth + 2;
        var atStart = list.scrollLeft <= 2, atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
        arrows.forEach(function (a) {
          a.hidden = !over;
          a.disabled = Number(a.getAttribute('data-sb-step')) < 0 ? atStart : atEnd;
        });
      };
      list.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(sync, 80); }, { passive: true });
      arrows.forEach(function (a) {
        a.addEventListener('click', function () {
          var item = list.firstElementChild;
          var step = item ? item.getBoundingClientRect().width + 16 : list.clientWidth * 0.8;
          list.scrollBy({ left: step * Number(a.getAttribute('data-sb-step')), behavior: still ? 'auto' : 'smooth' });
        });
      });
      window.addEventListener('resize', sync);
      sync();
    }
  }

  function initAll() { all(document, SECTION).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbx-ab-czm7r7-b-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.SbReviewsSection) return;
  window.SbReviewsSection = true;
  var SECTION = '[data-sb-section="sb-reviews"]';

  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function readJson(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }

  function init(root) {
    if (root.getAttribute('data-sb-ready') === '1') return;
    root.setAttribute('data-sb-ready', '1');
    var cfg = readJson(root.querySelector('[data-sb-config]'));
    var list = root.querySelector('[data-sb-list]');
    if (!cfg || !cfg.url || !list) return;
    var more = root.querySelector('[data-sb-more]');
    var star = root.querySelector('[data-sb-star]');
    var tick = root.querySelector('[data-sb-tick]');
    var per = Math.max(1, Number(cfg.perPage) || 6);
    var reviews = [], shown = 0, page = 1, next = null, remote = false, busy = false;
    var base;
    try { base = new URL(cfg.url, window.location.href); } catch (e) { return; }

    function stars(rating, max) {
      var wrap = el('span', 'sb-reviews__stars');
      wrap.setAttribute('aria-hidden', 'true');
      wrap.style.setProperty('--sb-fill', Math.max(0, Math.min(100, rating / (max || 5) * 100)) + '%');
      for (var r = 0; r < 2; r++) {
        var row = el('span', 'sb-reviews__stars-row' + (r ? ' sb-reviews__stars-row--fill' : ''));
        for (var i = 0; i < 5 && star; i++) row.appendChild(star.content.cloneNode(true));
        wrap.appendChild(row);
      }
      return wrap;
    }
    function safeUrl(u) {
      if (typeof u !== 'string' || !u) return null;
      try { var x = new URL(u, base); return /^https?:$/.test(x.protocol) ? x.toString() : null; } catch (e) { return null; }
    }
    function item(r) {
      var li = el('li', 'sb-reviews__item');
      var rating = Math.max(0, Math.min(5, Number(r.rating) || 0));
      var head = el('div', 'sb-reviews__item-head');
      var left = el('span');
      left.appendChild(stars(rating, 5));
      var said = el('span', 'sb-visually-hidden');
      said.textContent = rating + ' / 5';
      left.appendChild(said);
      head.appendChild(left);
      var d = r.date ? new Date(r.date) : null;
      if (d && !isNaN(d.getTime())) {
        var t = el('time', 'sb-reviews__date');
        t.dateTime = d.toISOString().slice(0, 10);
        t.textContent = d.toLocaleDateString(document.documentElement.lang || undefined, { year: 'numeric', month: 'short', day: 'numeric' });
        head.appendChild(t);
      }
      li.appendChild(head);
      if (r.title) { var h = el('h3', 'sb-reviews__title'); h.textContent = String(r.title); li.appendChild(h); }
      if (r.body) { var p = el('p', 'sb-reviews__text'); p.textContent = String(r.body); li.appendChild(p); }
      var photos = (Array.isArray(r.photos) ? r.photos : []).map(function (x) { return safeUrl(typeof x === 'string' ? x : x && x.url); }).filter(Boolean).slice(0, 4);
      if (photos.length) {
        var row = el('div', 'sb-reviews__photos');
        photos.forEach(function (src) {
          var a = el('a', 'sb-reviews__photo');
          a.href = src;
          a.target = '_blank';
          a.rel = 'noopener';
          var img = el('img');
          img.src = src;
          img.alt = cfg.photoAlt || '';
          img.loading = 'lazy';
          img.width = 72;
          img.height = 72;
          a.appendChild(img);
          row.appendChild(a);
        });
        li.appendChild(row);
      }
      var name = String(r.name || '').trim();
      if (name || (r.verified && cfg.verified)) {
        var by = el('p', 'sb-reviews__author');
        if (name) { var nm = el('span', 'sb-reviews__name'); nm.textContent = name; by.appendChild(nm); }
        if (r.verified && cfg.verified) {
          var vf = el('span', 'sb-reviews__verified');
          if (tick) vf.appendChild(tick.content.cloneNode(true));
          vf.appendChild(document.createTextNode(cfg.verified));
          by.appendChild(vf);
        }
        li.appendChild(by);
      }
      return li;
    }
    function summary(rating, count) {
      var box = root.querySelector('[data-sb-summary]');
      if (!box || box.hasAttribute('data-sb-from-shopify')) return;
      rating = Number(rating);
      count = Number(count);
      if (!(rating > 0) || !(count > 0)) return;
      box.querySelector('[data-sb-score]').textContent = (Math.round(rating * 10) / 10).toFixed(1);
      var s = box.querySelector('[data-sb-summary-stars]');
      if (s) s.style.setProperty('--sb-fill', Math.min(100, rating / 5 * 100) + '%');
      box.querySelector('[data-sb-based]').textContent = String(cfg.summary || '').replace('[count]', count.toLocaleString());
      box.hidden = false;
    }
    function target() {
      if (next) return safeUrl(next);
      var u = new URL(base.toString());
      if (cfg.product) u.searchParams.set('product', cfg.product);
      u.searchParams.set('page', String(page));
      u.searchParams.set('per', String(per));
      return u.toString();
    }
    function load() {
      var url = target();
      if (!url) return Promise.reject(new Error('bad link'));
      busy = true;
      if (more) more.disabled = true;
      return fetch(url, { headers: { Accept: 'application/json' } }).then(function (res) {
        if (!res.ok) throw new Error(String(res.status));
        return res.json();
      }).then(function (data) {
        data = data || {};
        var items = (Array.isArray(data.reviews) ? data.reviews : []).filter(function (r) { return r && (r.body || r.title) && Number(r.rating) > 0; });
        reviews = reviews.concat(items);
        next = typeof data.next === 'string' && data.next ? data.next : null;
        remote = items.length > 0 && !!(next || data.hasMore || (Number(data.pages) > Number(data.page || page)));
        page += 1;
        var sum = data.summary || {};
        summary(sum.rating != null ? sum.rating : data.average, sum.count != null ? sum.count : data.total);
      }).then(function () { busy = false; if (more) more.disabled = false; }, function (err) { busy = false; if (more) more.disabled = false; throw err; });
    }
    function render() {
      var end = Math.min(reviews.length, shown + per);
      for (; shown < end; shown++) list.appendChild(item(reviews[shown]));
      if (more) more.hidden = !(shown < reviews.length || remote);
      var box = root.querySelector('[data-sb-summary]');
      if (shown > 0 || (box && !box.hidden)) root.hidden = false;
    }
    if (more) more.addEventListener('click', function () {
      if (busy) return;
      if (shown < reviews.length) render();
      else if (remote) load().then(render).catch(function () { more.hidden = true; });
    });
    load().then(render).catch(function () {});
  }

  function initAll() { all(document, SECTION).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
